module.exports = __webpack_public_path__ + "img/selected3-min.dbb7c15a.png";